// extracted by mini-css-extract-plugin
export default {"container":"OrderDetails_container__QbOJn","number":"OrderDetails_number__J1Vdc"};